import { render } from "./ExamDetail.vue?vue&type=template&id=fbd4ba30&scoped=true"
import script from "./ExamDetail.vue?vue&type=script&lang=js"
export * from "./ExamDetail.vue?vue&type=script&lang=js"

import "./ExamDetail.vue?vue&type=style&index=0&id=fbd4ba30&scoped=true&lang=less"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbd4ba30"]])

export default __exports__